import { render, staticRenderFns } from "./404.vue?vue&type=template&id=309cb6b2&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=309cb6b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309cb6b2",
  null
  
)

export default component.exports